import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%', // Make it responsive
    minHeight: '100%',
    maxWidth: '420px', // Set the maximum width for larger screens
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
    [theme.fn.smallerThan(500)]: {
      maxWidth: '393px',
      gap: /* eslint-disable-line local-rules/use-theme-tokens */ '16px', // Reduce gap for smaller screens if needed
    },
    '& .mantine-Stepper-steps': {
      width: 'calc(100% + 4px)',
      marginLeft: /* eslint-disable-line local-rules/use-theme-tokens */ 10,
      marginBottom: theme.other.spacing._24,
      gap: 0,
      [theme.fn.smallerThan(500)]: {
        paddingLeft: /* eslint-disable-line local-rules/use-theme-tokens */ 60,
        paddingRight: /* eslint-disable-line local-rules/use-theme-tokens */ 60,
      },
    },
    '& .mantine-Stepper-separator': {
      height: 4,
      borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '4px',
      marginLeft: /* eslint-disable-line local-rules/use-theme-tokens */ -9,
    },
    '& .mantine-Stepper-separator:not(.mantine-Stepper-separatorActive)': {
      backgroundColor: '#0fefe2',
    },
    '& .mantine-Stepper-separator:not(.mantine-Stepper-separatorActive) ~ .mantine-Stepper-separator:not(.mantine-Stepper-separatorActive)':
      {
        backgroundColor: '#F1F3F5',
      },
  },

  stepFormContainer: {
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '24px 16px',
    [theme.fn.smallerThan(500)]: {
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ '12px',
    },
  },

  hiddenStep: {
    display: 'none',
  },

  // DEPRECATED
  // TODO: Confirm with @jason if ok to delete
  // stepper: {
  //   paddingTop: '20px',
  //   paddingBottom: '20px',
  // },
  // stepIcon: {
  //   color: '#4EE3C1',
  //   width: '78px',
  //   height: '4px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   borderRadius: '4%',
  //   fontSize: '12px',
  // },
  // formContainer: {
  //   display: 'flex',
  //   flexFlow: 'column nowrap',
  //   alignItems: 'center',
  //   gap: '16px',
  //   width: '100%',
  // },

  // headerContainer: {
  //   marginBottom: '32px',
  // },
  // buttonContainer: {
  //   marginTop: '64px',
  // },

  // stepBody: {
  //   display: 'none', // Hide step labels
  // },
  // stepLabel: {
  //   display: 'none', // Hide step labels
  // },
  // stepContent: {
  //   display: 'none', // Hide step labels
  // },
  // stepCompletedIcon: {
  //   display: 'none', // Hide completed step icon
  //   backgroundColor: '#4EE3C1', // Completed step color
  //   borderColor: '#4EE3C1',
  //   width: '78px',
  //   height: '4px',
  //   borderRadius: '4%',
  // },
  // separator: {
  //   height: '2px',
  //   backgroundColor: '#E0F7F4', // Default separator color
  //   '&[data-active="true"]': {
  //     backgroundColor: '#4EE3C1', // Active step separator color
  //   },
  //   '&[data-completed="true"]': {
  //     backgroundColor: '#4EE3C1', // Completed step separator color
  //   },
  // },
  // step: {
  //   backgroundColor: '#E0F7F4', // Default step background
  //   '&[data-active="true"]': {
  //     backgroundColor: '#4EE3C1', // Active step background
  //   },
  //   '&[data-completed="true"]': {
  //     backgroundColor: '#4EE3C1', // Completed step background
  //   },
  // },
}));

export default useStyles;
